import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { ArrowBack, SkipNext, Home } from '@mui/icons-material';

interface StepNavigationProps {
  onBack?: () => void;
  onSkip?: () => void;
  onBackToLetters?: () => void;
  canGoBack?: boolean;
  canSkip?: boolean;
  showBackToLetters?: boolean;
  backLabel?: string;
  skipLabel?: string;
  backToLettersLabel?: string;
}

const StepNavigation: React.FC<StepNavigationProps> = ({
  onBack,
  onSkip,
  onBackToLetters,
  canGoBack = true,
  canSkip = true,
  showBackToLetters = true,
  backLabel = "Назад",
  skipLabel = "Пропустить",
  backToLettersLabel = "К выбору буквы"
}) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        mt: 3,
        pt: 2,
        borderTop: '1px solid',
        borderColor: 'divider'
      }}
    >
      {/* Левая сторона - кнопки навигации */}
      <Box sx={{ display: 'flex', gap: 1 }}>
        {onBack && canGoBack && (
          <Tooltip title={backLabel}>
            <IconButton
              onClick={onBack}
              color="primary"
              size="large"
            >
              <ArrowBack />
            </IconButton>
          </Tooltip>
        )}
        
        {onSkip && canSkip && (
          <Tooltip title={skipLabel}>
            <IconButton
              onClick={onSkip}
              color="secondary"
              size="large"
            >
              <SkipNext />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {/* Правая сторона - возврат к выбору буквы */}
      {onBackToLetters && showBackToLetters && (
        <Tooltip title={backToLettersLabel}>
          <IconButton
            onClick={onBackToLetters}
            color="default"
            size="large"
          >
            <Home />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default StepNavigation;